module.exports = __webpack_public_path__ + "img/play.ce849406.png";